import {Component, HostListener, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormGroup} from "@angular/forms";
import {Observable, of} from "rxjs";
import {CellClickedEvent, ColDef, FirstDataRenderedEvent, GridApi, GridReadyEvent} from "ag-grid-community";
import {AgGridAngular} from "ag-grid-angular";
import {ImageCellrendererComponent} from "../../../components/ag-grid-cellrenderers/image-cellrenderer/image-cellrenderer.component";


@Component({
  selector: 'app-session-dialog',
  templateUrl: './order-session-dialog.component.html',
  styleUrls: ['./order-session-dialog.component.scss'],
})
export class OrderSessionDialogComponent implements OnInit {
  public form:FormGroup;
  private gridApi!: GridApi<any>;
  private totalResult:number=0
  // selectedDays: any =[];
  selectedDays: any;
  public pinnedTopRowData: any[];
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
  constructor(@Inject(MAT_DIALOG_DATA) public data: {name: any},public dialogRef: MatDialogRef<OrderSessionDialogComponent>) {
  }

  ngOnInit(): void {

  }

  close() {
      this.dialogRef.close();
  }


  createData(): any[] {
    const data = this.agGrid.rowData
    var result: any[] = [{
      'totalPrice': data.map(res => res.product.supplierPrice*res.quantity).reduce((a, b) => a + b, 0),
      quantity: data.map(res => res.quantity).reduce((a, b) => a + b, 0),
    }];

    return result;
  }

  getTotalPrice = ($param: any) => {
    if($param.rowIndex == 0 && $param.data.totalPrice != undefined){
      return $param.data.totalPrice;
    }
    const productObj = $param.data;
    const total = productObj.product?.supplierPrice * productObj.quantity;
    this.totalResult = this.totalResult + total;
    return total
  }

  public columnDefs: ColDef[] = [
    { field: 'product.barCode',headerName:'ברקוד', sortable: true, resizable: true, maxWidth:150},
    { field: 'product.generatedBarcode',headerName:'ברקוד מחושב', sortable: true, resizable: true, maxWidth:150},
    { field: 'product.name',headerName:'שם מוצר', sortable: true, resizable: true},
    { field: 'product.supplierPrice',headerName:'מחיר', sortable: true, resizable: true, maxWidth:100},
    { field: 'quantity',headerName:'כמות', sortable: true, resizable: true, maxWidth:100},
    { field: '',headerName:'סך הכל', sortable: true, resizable: true, cellRenderer: this.getTotalPrice, maxWidth:100},
    { field: 'product.images',headerName:'תמונות מוצר', sortable: false, resizable: true, cellRenderer: ImageCellrendererComponent},
    { field: 'freeText',headerName:'תיאור מוצר', sortable: true, resizable: true}
  ];
  defaultColDef: any;
  public rowData$!: Observable<{ name: any }>;

  onGridReady($event: GridReadyEvent<any>) {
    this.rowData$ = of(this.data);
  }

  onFirstDataRendered($event: FirstDataRenderedEvent<any>) {
    this.agGrid.api.sizeColumnsToFit()
    this.pinnedTopRowData = this.createData()
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(event.target.innerWidth > 1500){
      this.agGrid.api.sizeColumnsToFit()
    }
  }

  onCellClicked($event: CellClickedEvent<any>) {

  }
}
